module.exports = __webpack_public_path__ + "img/homepage-support.10b99b7.svg";